import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import ClassicUpgrade from "../classic/ClassicUpgrade";
import UpgradeCostCalculator from "../classic/UpgradeCostCalculator";
import { UpgradeCostUnit } from "../UpgradeCostUnit";

/**
 * @abstract
 */
export default class GoldUpgrade extends ClassicUpgrade {
    /**
     * @param {string} id
     * @param {string} title
     * @param {string} iconFileName
     * @param {UpgradeCostCalculator} upgradeCostCalculator 
     * @param {number} maxCount
     * @param {Totals} totals
     */
    constructor(id, title, iconFileName, upgradeCostCalculator, maxCount, totals) {
        super(id, title, iconFileName, upgradeCostCalculator, maxCount);

        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;

        // This must be invoked here
        this.initializeCosts();
    }

    // NOTE: SUB-CLASSES MUST OVERRIDE getDescription()

    //////////////////////////////////////
    // Upgrade overrides
    //////////////////////////////////////

    /**
     * @override
     * @returns {string} See UpgradeCostUnit
     */
    getCostUnit() {
        return UpgradeCostUnit.GOLD;
    }

    //////////////////////////////////////
    // ClassicUpgrade overrides
    //////////////////////////////////////

    /**
     * @override
     * @returns {BigNum}
     */
    getMoney() {
        return this.totals.gold;
    }

    /**
     * @override
     * @param {BigNum} money 
     */
    decrementMoney(money) {
        this.totals.decrementGold(money);
    }
}